













































import _ from 'lodash'
import moment from 'moment'
import { DataTablePagination } from '@/types/_'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import ModalRegraDeCalculoIncluirLocaisExecucao from './ModalRegraDeCalculoIncluirLocaisExecucao.vue'
import EventBus from '@/plugins/EventBus'

@Component({
  components: {
    ModalRegraDeCalculoIncluirLocaisExecucao
  },
})
export default class LocaisExecucaoDataTable extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadLocalExecucao: boolean = false
  get loadingLocalExecucao() { return this.loadLocalExecucao }
  set loadingLocalExecucao(value: boolean) { this.loadLocalExecucao = value }

  get header() {
    return [
      { text: 'Nome local de execução', value: 'localExecucaoNome', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get itemsLocalExecucao() {
    return this.getRegrasDeCalculoStore.localExecucaoRegraCalculo || []
  }
  get paginacaoLocalExecucao() { return this.getRegrasDeCalculoStore.paginacaoLocalExecucao }
  localExecucaoDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getLocalExecucaoByRegraCalculoId(param), 700)

  updatePagination(pagination: DataTablePagination) {
    this.loadingLocalExecucao = true
    this.getRegrasDeCalculoStore.setPaginacaoLocalExecucao(pagination)
    this.localExecucaoDebounced(pagination)
    this.loadingLocalExecucao = false
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  loadDeletarLocalExecucao: string = ''
  get loadingDeletarLocalExecucao() { return this.loadDeletarLocalExecucao }
  set loadingDeletarLocalExecucao(value: string) { this.loadDeletarLocalExecucao = value }

  get showModalAddRegraCalculoLocalExecucao() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoLocaisExecucao }
  set showModalAddRegraCalculoLocalExecucao(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoLocaisExecucao', value }) }

  async removeRegraCalculoLocalExecucao(regraId: string) {
    this.loadingDeletarLocalExecucao = regraId
    const request = await this.getRegrasDeCalculoStore.removeLocalExecucao(regraId)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeletarLocalExecucao = ''
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Local excluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingDeletarLocalExecucao = ''
  }
}
